import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { HttpService } from '~/core/services/http.service';
import { AppSettingsService } from '~/core/services/appsettings.service';

@Component({
    selector: 'wells-schema-editor',
    templateUrl: './wells-schema-editor.component.html',
    styleUrls: ['./wells-schema-editor.component.scss'],
    standalone: false
})
export class WellsSchemaEditorComponent implements OnInit {
    @Input() wellName: string = '';
    @Input() schemaType: string = '';
    @Input() schemaData: any = null;
    @Output() suggestionsSaved = new EventEmitter<any>();
    @Output() closeEditor = new EventEmitter<void>();

    public suggestions: any[] = [];
    public isLoading: boolean = false;
    public error: string = '';
    public userId: string = '';

    constructor(
        private httpService: HttpService,
        private appSettingsService: AppSettingsService
    ) {}

    async ngOnInit() {
        const settings = await this.appSettingsService.getSettings();
        this.userId = settings?.user?.username || settings?.user?.email || 'unknown_user';
        
        if (this.schemaData) {
            this.initializeSuggestions();
        }
    }

    private initializeSuggestions() {
        this.suggestions = this.flattenSchemaForEditing(this.schemaData);
    }

    private flattenSchemaForEditing(data: any, prefix: string = ''): any[] {
        const result: any[] = [];
        
        if (!data || typeof data !== 'object') {
            return result;
        }

        for (const [key, value] of Object.entries(data)) {
            const fieldName = prefix ? `${prefix}.${key}` : key;
            
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                result.push(...this.flattenSchemaForEditing(value, fieldName));
            } else {
                result.push({
                    field: fieldName,
                    originalValue: value,
                    currentValue: value,
                    type: typeof value,
                    isModified: false
                });
            }
        }
        
        return result;
    }

    public onValueChange(suggestion: any, newValue: any) {
        suggestion.currentValue = newValue;
        suggestion.isModified = suggestion.originalValue !== newValue;
    }

    public async saveSuggestions() {
        const modifiedSuggestions = this.suggestions.filter(s => s.isModified);
        
        if (modifiedSuggestions.length === 0) {
            this.error = 'No changes to save';
            return;
        }

        this.isLoading = true;
        this.error = '';

        try {
            const suggestionsToSave = modifiedSuggestions.map(s => ({
                field: s.field,
                originalValue: s.originalValue,
                suggestedValue: s.currentValue,
                type: s.type
            }));
            console.log(this.schemaType,"schema")
            this.httpService.saveEngineerSuggestions(
                this.wellName,
                this.schemaType,
                this.userId,
                suggestionsToSave
            ).subscribe({
                next: (response: any) => {
                    this.suggestionsSaved.emit(response);
                    this.isLoading = false;
                },
                error: (error: any) => {
                    this.error = `Failed to save suggestions: ${error.message}`;
                    this.isLoading = false;
                }
            });

        } catch (error: any) {
            this.error = `Error saving suggestions: ${error.message}`;
            this.isLoading = false;
        }
    }

    public resetChanges() {
        this.suggestions.forEach(s => {
            s.currentValue = s.originalValue;
            s.isModified = false;
        });
    }

    public close() {
        this.closeEditor.emit();
    }

    public trackBySuggestion(index: number, suggestion: any): string {
        return suggestion.field;
    }

    public hasPendingChanges(): boolean {
        return this.suggestions.some(s => s.isModified);
    }
}
